import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
// import { addFlashMessage } from '../../../actions'
import Clinic from './Clinic'
import Speciality from './Speciality'
import {
  getCheckInAppointment,
  getSpecialities,
  getWaitingTimes,
  recoverOldCheckInAppointmentData
} from '../../api'
import { showLoader, hideLoader } from '../../actions'
import to from 'await-catch'
import moment from 'moment'

const FormER = ({ setSubmitedTurn, submitedTurn, showLoader, hideLoader, clear, auth }) => {
  const [specialities, setSpecialities] = useState([])
  const [clinics, setClinics] = useState([])

  useEffect(() => {
    const fetchData = async () => {
      try {
        showLoader()

        const [err, [{ data: specsData } = {}]] = await to([getSpecialities()])

        if (err) throw new Error('Error fetching specialities')

        setSpecialities(specsData)
      } catch (error) {
        console.log(error)
      } finally {
        hideLoader()
      }
    }

    fetchData()
  }, [])

  const saveSpeciality = speciality => {
    setSubmitedTurn({ ...submitedTurn, speciality: speciality })
  }

  const saveClinic = async clinic => {
    await obtainTurn(clinic)
  }

  const obtainTurn = async clinic => {
    try {
      showLoader()

      const params = {
        clinica: clinic.id,
        especialidad: submitedTurn.speciality.id,
        fecha: moment(clinic.waitTime).format('DD/MM/YYYY HH:mm'),
        nroDoc: auth.nroDocumento,
        email: auth.mail
      }

      const [err, { data } = {}] = await to(getCheckInAppointment(params))
      if (err) throw new Error('Error al obtener turno')

      if (!err) {
        if (!data.nuevo) {
          const [err, { data: oldApp } = {}] = await to(
            recoverOldCheckInAppointmentData({
              clinic: clinic.id,
              appointment: data.turno
            })
          )
          if (!err) {
            clinic.waitingTime = moment(oldApp.fechaTurnoDateTime)
          }
        }
        setSubmitedTurn({ ...submitedTurn, clinic: clinic, turno: data.turno })
      }

      setSubmitedTurn(prev => ({
        ...prev,
        clinic: clinic,
        isSubmited: true
      }))
    } catch (error) {
      console.error(error)
      clear()
    } finally {
      hideLoader()
    }
  }

  useEffect(
    () => {
      const fetchClinics = async () => {
        try {
          showLoader()
          const [err, { data } = {}] = await to(getWaitingTimes(submitedTurn.speciality.id))

          if (err) throw new Error('Error en el fetch de clinicas')

          setClinics(data)
        } catch (error) {
          console.log(error)
        } finally {
          hideLoader()
        }
      }

      if (submitedTurn.speciality !== null) {
        fetchClinics()
      }
    },
    [submitedTurn.speciality]
  )

  return (
    <>
      {submitedTurn.speciality === null ? (
        <Speciality saveSpeciality={saveSpeciality} specialities={specialities} />
      ) : (
        <Clinic saveClinic={saveClinic} clinics={clinics} clear={clear} speciality={submitedTurn.speciality} />
      )}
    </>
  )
}

const mapStateToProps = ({ auth }) => {
  return { auth }
}

const mapDispatchToProps = {
  showLoader,
  hideLoader
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FormER)
